module.exports = __webpack_public_path__ + "img/badge.40bd91b4.svg";